import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    'address1Label',
    'address2Label',
    'businessRadio',
    'companyName',
    'companyNameLabel',
    'companyNameWrapper',
    'companyNumber',
    'firstNameLabel',
    'lastNameLabel',
    'vatNumber'
  ]

  connect() {
  }

  switchToBusiness() {
    this.address1LabelTarget.innerHTML = '<abbr title="required">*</abbr>Company address line 1'
    this.address2LabelTarget.innerHTML = 'Company address line 2'
    this.companyNameLabelTarget.classList.add('required')
    this.companyNameLabelTarget.classList.remove('optional')
    this.companyNameLabelTarget.innerHTML = '<abbr title="required">*</abbr>Company name'
    this.companyNameTarget.required = true
    this.companyNameTarget.classList.add('required')
    this.companyNameTarget.classList.remove('optional')
    this.companyNameWrapperTarget.classList.remove('hidden')
    this.companyNameWrapperTarget.classList.add('required')
    this.companyNumberTarget.classList.remove('hidden')
    this.firstNameLabelTarget.innerHTML = '<abbr title="required">*</abbr>Contact first name'
    this.lastNameLabelTarget.innerHTML = '<abbr title="required">*</abbr>Contact last name'
    this.vatNumberTarget.classList.remove('hidden')
  }

  switchToPersonal() {
    this.address1LabelTarget.innerHTML = '<abbr title="required">*</abbr>Address line 1'
    this.address2LabelTarget.innerHTML = 'Address line 2'
    this.companyNameLabelTarget.classList.remove('required')
    this.companyNameLabelTarget.classList.add('optional')
    this.companyNameLabelTarget.innerHTML = 'Company name'
    this.companyNameTarget.required = false
    this.companyNameTarget.classList.remove('required')
    this.companyNameTarget.classList.add('optional')
    this.companyNameWrapperTarget.classList.remove('required')
    this.companyNameWrapperTarget.classList.add('hidden')
    this.companyNumberTarget.classList.add('hidden')
    this.firstNameLabelTarget.innerHTML = '<abbr title="required">*</abbr>First name'
    this.lastNameLabelTarget.innerHTML = '<abbr title="required">*</abbr>Last name'
    this.vatNumberTarget.classList.add('hidden')
  }

  toggle() {
    if (this.businessRadioTarget.checked) {
      this.switchToPersonal()
    } else {
      this.switchToBusiness()
    }
  }
}
